const $document = $(document);

/**
 * Handle Change Price
 */
const handleChangePrice = () => {
  $document.on('change', '.js-pdp-item .js-product-main-select', function() {
    const $this = $(this);
    const $parent = $this.closest('.js-pdp');
    const $priceContainer = $parent.find('.js-product-item-price');
    const $currentVariant = $this.find('option:selected');
    const thisPrice = $currentVariant.data('price');

    $priceContainer.html(thisPrice);
  });
}

handleChangePrice();
